import { useState } from "react";
import Sidebar from "../../Components/Sidebar/Sidebar";
import Header from "../../Components/Header/Header";
import classes from "./Dashboard.module.css";

import {
    FaUsers,
    FaUserPlus,
    FaCalendarCheck,
    FaAmbulance,
    FaClock,
    FaFlask,
    FaDollarSign,
    FaBed,
    FaPlus,
    FaChevronLeft,
    FaChevronRight,
    FaArrowUp,
    FaArrowDown,
    FaPills,
    FaShieldAlt,
} from "react-icons/fa";

/* ===========================
   DASHBOARD STATISTICS
=========================== */

const stats = [
    {
        title: "Total Patients Today",
        value: "1,248",
        change: "12.5%",
        direction: "up",
        color: "#2563EB",
        bg: "#EFF6FF",
        icon: <FaUsers />,
    },
    {
        title: "Admitted Patients",
        value: "152",
        change: "8.3%",
        direction: "up",
        color: "#7C3AED",
        bg: "#F5F3FF",
        icon: <FaUserPlus />,
    },
    {
        title: "Appointments Today",
        value: "324",
        change: "13.2%",
        direction: "up",
        color: "#F59E0B",
        bg: "#FFF7ED",
        icon: <FaCalendarCheck />,
    },
    {
        title: "Emergency Cases",
        value: "56",
        change: "4.1%",
        direction: "down",
        color: "#EF4444",
        bg: "#FEF2F2",
        icon: <FaAmbulance />,
    },
    {
        title: "Pending Prescriptions",
        value: "87",
        change: "6.7%",
        direction: "up",
        color: "#EC4899",
        bg: "#FDF2F8",
        icon: <FaClock />,
    },
    {
        title: "Pending Lab Tests",
        value: "136",
        change: "6.5%",
        direction: "up",
        color: "#06B6D4",
        bg: "#ECFEFF",
        icon: <FaFlask />,
    },
    {
        title: "Revenue Today",
        value: "$28,650",
        change: "6.6%",
        direction: "up",
        color: "#22C55E",
        bg: "#ECFDF5",
        icon: <FaDollarSign />,
    },
    {
        title: "Available Beds",
        value: "68",
        change: "8.2%",
        direction: "up",
        color: "#8B5CF6",
        bg: "#F5F3FF",
        icon: <FaBed />,
    },
];

/* ===========================
   REVENUE DATA - Daily, Weekly, Monthly
=========================== */

const revenueData = {
    daily: [
        { day: "15 May", amount: 20000 },
        { day: "16 May", amount: 29000 },
        { day: "17 May", amount: 28000 },
        { day: "18 May", amount: 43000 },
        { day: "19 May", amount: 32000 },
        { day: "20 May", amount: 39000 },
        { day: "21 May", amount: 46000 },
    ],
    weekly: [
        { day: "15 May", amount: 12000 },
        { day: "16 May", amount: 22000 },
        { day: "17 May", amount: 20000 },
        { day: "18 May", amount: 29000 },
        { day: "19 May", amount: 24000 },
        { day: "20 May", amount: 30000 },
        { day: "21 May", amount: 37000 },
    ],
    monthly: [
        { day: "15 May", amount: 7000 },
        { day: "16 May", amount: 15000 },
        { day: "17 May", amount: 14000 },
        { day: "18 May", amount: 19000 },
        { day: "19 May", amount: 16000 },
        { day: "20 May", amount: 21000 },
        { day: "21 May", amount: 28000 },
    ],
};

/* ===========================
   PATIENT VISITS DATA
=========================== */

const patientVisitsData = [
    { label: "Outpatients", value: 642, color: "#7C3AED" },
    { label: "Inpatients", value: 321, color: "#22C55E" },
    { label: "Emergency", value: 152, color: "#EF4444" },
    { label: "Follow-up", value: 213, color: "#F59E0B" },
];

/* ===========================
   BED OCCUPANCY DATA - Donut Chart
=========================== */

const bedOccupancyData = [
    { label: "Occupied Beds", value: 182, percentage: 72.8, color: "#22C55E" },
    { label: "Available Beds", value: 68, percentage: 27.2, color: "#F59E0B" },
];

const bedDetailsData = [
    { label: "Acute care beds", value: 68, percentage: 27.2, color: "#8B5CF6" },
    { label: "ICU beds", value: 18, percentage: 90, color: "#EF4444" },
    { label: "Maternity beds", value: 12, percentage: 60, color: "#EC4899" },
];

/* ===========================
   APPOINTMENT SCHEDULE
=========================== */

const appointments = [
    { time: "09:00 AM", patient: "John Doe", doctor: "Dr. Smith", department: "Cardiology", beds: "Waiting" },
    { time: "09:30 AM", patient: "Mary Jane", doctor: "Dr. Peter", department: "Pediatrics", beds: "In Progress" },
    { time: "10:00 AM", patient: "Robert Brown", doctor: "Dr. William", department: "Orthopedics", beds: "Confirmed" },
    { time: "10:30 AM", patient: "Linda Wee", doctor: "Dr. Taylor", department: "Dermatology", beds: "Waiting" },
    { time: "11:00 AM", patient: "Michael Lee", doctor: "Dr. Johnson", department: "Neurology", beds: "Confirmed" },
];

/* ===========================
   RECENT ADMISSIONS
=========================== */

const recentAdmissions = [
    {
        patient: "James Anderson",
        ward: "General Ward",
        doctor: "Dr. Smith",
        admittedDate: "21 May 2024",
        status: "Admitted",
        priority: "High",
    },
    {
        patient: "Patricia White",
        ward: "Private Room",
        doctor: "Dr. Williams",
        admittedDate: "21 May 2024",
        status: "Admitted",
        priority: "High",
    },
    {
        patient: "Robert Johnson",
        ward: "ICU",
        doctor: "Dr. Brown",
        admittedDate: "20 May 2024",
        status: "Admitted",
        priority: "Critical",
    },
    {
        patient: "Linda Davis",
        ward: "Maternity Ward",
        doctor: "Dr. Taylor",
        admittedDate: "20 May 2024",
        status: "Admitted",
        priority: "Critical",
    },
    {
        patient: "William Miller",
        ward: "General Ward",
        doctor: "Dr. Johnson",
        admittedDate: "19 May 2024",
        status: "Discharged",
        priority: "Low",
    },
];

/* ===========================
   EMERGENCY CASES
=========================== */

const emergencyCases = [
    { patient: "John Smith", priority: "High", arrivedTime: "09:00 AM", doctor: "Dr. Smith", status: "In Progress" },
    { patient: "Sarah Davis", priority: "High", arrivedTime: "09:00 AM", doctor: "Dr. Williams", status: "In Progress" },
    { patient: "Brian Wilson", priority: "Critical", arrivedTime: "09:00 AM", doctor: "Dr. Taylor", status: "In Progress" },
    { patient: "Lisa Martinez", priority: "Critical", arrivedTime: "09:00 AM", doctor: "Dr. Johnson", status: "In Progress" },
    { patient: "Thomas Lee", priority: "Low", arrivedTime: "09:00 AM", doctor: "Dr. Brown", status: "In Progress" },
];

/* ===========================
   RECENT ACTIVITIES
=========================== */

const recentActivities = [
    { activity: "New patient: John Doe registered", time: "10:15 AM" },
    { activity: "Lab results for Sarah Davis #12345 uploaded", time: "09:45 AM" },
    { activity: "Payment of $250 received from Mary Jones", time: "09:30 AM" },
    { activity: "Patient Robert just returns discharged", time: "09:30 AM" },
    { activity: "Prescription for Linda Davis issued", time: "09:30 AM" },
];

/* ===========================
   CALENDAR EVENTS
=========================== */

const calendarEvents = [
    { event: "Cardiology Surgeries", status: "In Progress" },
    { event: "In Progress", status: "In Progress" },
    { event: "Public Holiday", status: "All Day" },
];

/* ===========================
   COMPONENT
=========================== */

function Dashboard() {
    const [activeRevenueTab, setActiveRevenueTab] = useState("Daily");
    const [currentPage, setCurrentPage] = useState(1);
    const rowsPerPage = 5;
    const totalPages = Math.ceil(recentAdmissions.length / rowsPerPage);

    const currentAdmissions = recentAdmissions.slice(
        (currentPage - 1) * rowsPerPage,
        currentPage * rowsPerPage
    );

    const handlePrevious = () => {
        if (currentPage > 1) {
            setCurrentPage((prev) => prev - 1);
        }
    };

    const handleNext = () => {
        if (currentPage < totalPages) {
            setCurrentPage((prev) => prev + 1);
        }
    };

    // Get current revenue data based on active tab
    const getRevenueData = () => {
        switch(activeRevenueTab) {
            case "Daily": return revenueData.daily;
            case "Weekly": return revenueData.weekly;
            case "Monthly": return revenueData.monthly;
            default: return revenueData.daily;
        }
    };

    const currentRevenueData = getRevenueData();
    const maxRevenue = Math.max(...currentRevenueData.map(item => item.amount));
    const maxVisits = Math.max(...patientVisitsData.map(item => item.value));

    // Calculate total beds for donut chart
    const totalBeds = bedOccupancyData.reduce((sum, item) => sum + item.value, 0);

    return (
        <div className={classes.page}>
            <Sidebar />
            <div className={classes.main}>
                <Header />
                <div className={classes.content}>
                    {/* PAGE HEADER */}
                    <div className={classes.topSection}>
                        <div>
                            <h2 className={classes.pageTitle}>Dashboard</h2>
                            <p className={classes.breadcrumb}>
                                Welcome back, Admin User!
                            </p>
                        </div>
                        <div className={classes.topRight}>
                            <span className={classes.date}>Tuesday, 21 May 2024</span>
                            <button className={classes.quickActionsBtn}>
                                <FaPlus />
                                <span>Quick Actions</span>
                            </button>
                        </div>
                    </div>

                    {/* STATISTICS GRID */}
                    <div className={classes.statsGrid}>
                        {stats.map((item, index) => (
                            <div key={index} className={classes.statCard}>
                                <div
                                    className={classes.iconBox}
                                    style={{
                                        background: item.bg,
                                        color: item.color,
                                    }}
                                >
                                    {item.icon}
                                </div>
                                <div className={classes.statContent}>
                                    <p className={classes.statTitle}>{item.title}</p>
                                    <h2 className={classes.statValue}>{item.value}</h2>
                                    <div
                                        className={classes.statChange}
                                        style={{
                                            color: item.direction === "up" ? "#16A34A" : "#EF4444",
                                        }}
                                    >
                                        {item.direction === "up" ? <FaArrowUp /> : <FaArrowDown />}
                                        <span>{item.change} from yesterday</span>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>

                    {/* CHARTS ROW 1 - Revenue Overview & Patient Visits */}
                    <div className={classes.chartsRow}>
                        {/* Revenue Overview - Bar Chart */}
                        <div className={classes.chartCard}>
                            <div className={classes.cardHeader}>
                                <h3>Revenue Overview</h3>
                                <div className={classes.chartTabs}>
                                    <button 
                                        className={activeRevenueTab === "Daily" ? classes.activeChartTab : classes.chartTab}
                                        onClick={() => setActiveRevenueTab("Daily")}
                                    >
                                        Daily
                                    </button>
                                    <button 
                                        className={activeRevenueTab === "Weekly" ? classes.activeChartTab : classes.chartTab}
                                        onClick={() => setActiveRevenueTab("Weekly")}
                                    >
                                        Weekly
                                    </button>
                                    <button 
                                        className={activeRevenueTab === "Monthly" ? classes.activeChartTab : classes.chartTab}
                                        onClick={() => setActiveRevenueTab("Monthly")}
                                    >
                                        Monthly
                                    </button>
                                </div>
                            </div>
                            <div className={classes.chartContainer}>
                                <div className={classes.barChart}>
                                    {currentRevenueData.map((item, index) => (
                                        <div key={index} className={classes.barWrapper}>
                                            <div
                                                className={classes.bar}
                                                style={{
                                                    height: `${(item.amount / maxRevenue) * 100}%`,
                                                    background: `linear-gradient(180deg, #2563EB, #60A5FA)`,
                                                }}
                                            />
                                            <span className={classes.barLabel}>{item.day}</span>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>

                        {/* Patient Visits - Horizontal Bar Chart */}
                        <div className={classes.chartCard}>
                            <div className={classes.cardHeader}>
                                <h3>Patient Visits</h3>
                                <span className={classes.weekLabel}>This Week</span>
                            </div>
                            <div className={classes.chartContainer}>
                                <div className={classes.visitsChart}>
                                    {patientVisitsData.map((item, index) => (
                                        <div key={index} className={classes.visitsItem}>
                                            <span className={classes.visitsLabel}>{item.label}</span>
                                            <div className={classes.visitsBarWrapper}>
                                                <div 
                                                    className={classes.visitsBar} 
                                                    style={{ 
                                                        width: `${(item.value / maxVisits) * 100}%`, 
                                                        background: item.color 
                                                    }}
                                                >
                                                    <span>{item.value}</span>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* CHARTS ROW 2 - Bed Occupancy (Donut Chart) & Appointment Schedule */}
                    <div className={classes.chartsRow}>
                        {/* Bed Occupancy - Donut Chart */}
                        <div className={classes.chartCard}>
                            <div className={classes.cardHeader}>
                                <h3>Bed Occupancy</h3>
                            </div>
                            <div className={classes.bedContainer}>
                                <div className={classes.donutContainer}>
                                    <div className={classes.donutChart}>
                                        <svg viewBox="0 0 100 100" className={classes.donutSvg}>
                                            {bedOccupancyData.map((item, index) => {
                                                const circumference = 2 * Math.PI * 40;
                                                const offset = circumference - (item.percentage / 100) * circumference;
                                                // Calculate cumulative offset for previous segments
                                                let cumulativeOffset = 0;
                                                for (let i = 0; i < index; i++) {
                                                    cumulativeOffset += (bedOccupancyData[i].percentage / 100) * circumference;
                                                }
                                                return (
                                                    <circle
                                                        key={index}
                                                        cx="50"
                                                        cy="50"
                                                        r="40"
                                                        fill="transparent"
                                                        stroke={item.color}
                                                        strokeWidth="16"
                                                        strokeDasharray={circumference}
                                                        strokeDashoffset={offset + cumulativeOffset}
                                                        strokeLinecap="round"
                                                        className={classes.donutSegment}
                                                        style={{
                                                            transform: "rotate(-90deg)",
                                                            transformOrigin: "50% 50%",
                                                        }}
                                                    />
                                                );
                                            })}
                                        </svg>
                                        <div className={classes.donutCenter}>
                                            <strong>{totalBeds}</strong>
                                            <span>Total Beds</span>
                                        </div>
                                    </div>
                                    <div className={classes.donutLegend}>
                                        {bedOccupancyData.map((item, index) => (
                                            <div key={index} className={classes.legendItem}>
                                                <span className={classes.legendDot} style={{ background: item.color }} />
                                                <span className={classes.legendLabel}>{item.label}</span>
                                                <span className={classes.legendValue}>{item.value}</span>
                                                <span className={classes.legendPercentage}>{item.percentage}%</span>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                                <div className={classes.bedDetails}>
                                    {bedDetailsData.map((item, index) => (
                                        <div key={index} className={classes.bedDetailItem}>
                                            <span className={classes.bedDetailDot} style={{ background: item.color }} />
                                            <span className={classes.bedDetailLabel}>{item.label}</span>
                                            <span className={classes.bedDetailValue}>{item.value}</span>
                                            <span className={classes.bedDetailPercentage}>{item.percentage}%</span>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>

                        {/* Appointment Schedule */}
                        <div className={classes.chartCard}>
                            <div className={classes.cardHeader}>
                                <h3>Appointment Schedule</h3>
                                <span className={classes.weekLabel}>This Week</span>
                            </div>
                            <div className={classes.appointmentList}>
                                <div className={classes.appointmentHeader}>
                                    <span>Time</span>
                                    <span>Patient</span>
                                    <span>Doctor</span>
                                    <span>Department</span>
                                    <span>Beds</span>
                                </div>
                                {appointments.map((appointment, index) => (
                                    <div key={index} className={classes.appointmentItem}>
                                        <span className={classes.appointmentTime}>{appointment.time}</span>
                                        <span className={classes.appointmentPatient}>{appointment.patient}</span>
                                        <span className={classes.appointmentDoctor}>{appointment.doctor}</span>
                                        <span className={classes.appointmentDept}>{appointment.department}</span>
                                        <span className={`${classes.appointmentBeds} ${
                                            appointment.beds === "Waiting" ? classes.waitingBed :
                                            appointment.beds === "In Progress" ? classes.inProgressBed :
                                            classes.confirmedBed
                                        }`}>
                                            {appointment.beds}
                                        </span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>

                    {/* SUMMARY CARDS GRID */}
                    <div className={classes.summaryGrid}>
                        {/* Laboratory Status */}
                        <div className={classes.summaryCard}>
                            <div className={classes.cardHeader}>
                                <h3>Laboratory Status</h3>
                            </div>
                            <div className={classes.summaryItem}>
                                <span>Pending Tests</span>
                                <strong>136</strong>
                            </div>
                            <div className={classes.summaryItem}>
                                <span>Completed Today</span>
                                <strong>329</strong>
                            </div>
                            <div className={classes.summaryItem}>
                                <span>Critical Results</span>
                                <strong>12</strong>
                            </div>
                            <div className={classes.summaryItem}>
                                <span>Rejected Samples</span>
                                <strong>05</strong>
                            </div>
                        </div>

                        {/* Pharmacy Summary */}
                        <div className={classes.summaryCard}>
                            <div className={classes.cardHeader}>
                                <h3>Pharmacy Summary</h3>
                            </div>
                            <div className={classes.summaryItem}>
                                <span>Pre-Orders Today</span>
                                <strong>184</strong>
                            </div>
                            <div className={classes.summaryItem}>
                                <span>Low Stock Medicines</span>
                                <strong>23</strong>
                            </div>
                            <div className={classes.summaryItem}>
                                <span>Expired Drugs</span>
                                <strong>07</strong>
                            </div>
                            <div className={classes.summaryItem}>
                                <span>Pending Disordering</span>
                                <strong>42</strong>
                            </div>
                        </div>

                        {/* Insurance / HMO */}
                        <div className={classes.summaryCard}>
                            <div className={classes.cardHeader}>
                                <h3>Insurance / HMO</h3>
                            </div>
                            <div className={classes.summaryItem}>
                                <span>Claims Submitted</span>
                                <strong>46</strong>
                            </div>
                            <div className={classes.summaryItem}>
                                <span>Claims Approved</span>
                                <strong>31</strong>
                            </div>
                            <div className={classes.summaryItem}>
                                <span>Pending Claims</span>
                                <strong>12</strong>
                            </div>
                            <div className={classes.summaryItem}>
                                <span>Rejected Claims</span>
                                <strong>03</strong>
                            </div>
                        </div>

                        {/* Financial Summary */}
                        <div className={classes.summaryCard}>
                            <div className={classes.cardHeader}>
                                <h3>Financial Summary</h3>
                            </div>
                            <div className={classes.summaryItem}>
                                <span>Invoices Generated</span>
                                <strong>$45,870</strong>
                            </div>
                            <div className={classes.summaryItem}>
                                <span>Payments Received</span>
                                <strong>$28,650</strong>
                            </div>
                            <div className={classes.summaryItem}>
                                <span>Outstanding Bills</span>
                                <strong>$17,220</strong>
                            </div>
                            <div className={classes.summaryItem}>
                                <span>Refunds</span>
                                <strong>$1,250</strong>
                            </div>
                        </div>

                        {/* Staff Attendance */}
                        <div className={classes.summaryCard}>
                            <div className={classes.cardHeader}>
                                <h3>Staff Attendance</h3>
                            </div>
                            <div className={classes.summaryItem}>
                                <span>Doctors On Duty</span>
                                <strong>28</strong>
                            </div>
                            <div className={classes.summaryItem}>
                                <span>Nurses On Duty</span>
                                <strong>64</strong>
                            </div>
                            <div className={classes.summaryItem}>
                                <span>Staff Absent</span>
                                <strong>08</strong>
                            </div>
                            <div className={classes.summaryItem}>
                                <span>Shift Changes</span>
                                <strong>03</strong>
                            </div>
                        </div>

                        {/* Quick Overview */}
                        <div className={classes.summaryCard}>
                            <div className={classes.cardHeader}>
                                <h3>Quick Overview</h3>
                            </div>
                            <div className={classes.summaryItem}>
                                <span>Total Revenue</span>
                                <strong>$28,650</strong>
                            </div>
                            <div className={classes.summaryItem}>
                                <span>Bed Occupancy</span>
                                <strong>72.8%</strong>
                            </div>
                            <div className={classes.summaryItem}>
                                <span>Patient Satisfaction</span>
                                <strong>94%</strong>
                            </div>
                            <div className={classes.summaryItem}>
                                <span>Avg Wait Time</span>
                                <strong>18 min</strong>
                            </div>
                        </div>
                    </div>

                    {/* BOTTOM SECTION */}
                    <div className={classes.bottomSection}>
                        {/* Recent Admissions */}
                        <div className={classes.admissionsCard}>
                            <div className={classes.cardHeader}>
                                <h3>Recent Admissions</h3>
                                <span className={classes.viewAll}>View All</span>
                            </div>
                            <div className={classes.tableWrapper}>
                                <table className={classes.admissionsTable}>
                                    <thead>
                                        <tr>
                                            <th>Patient</th>
                                            <th>Ward</th>
                                            <th>Doctor</th>
                                            <th>Admitted Date</th>
                                            <th>Status</th>
                                            <th>Priority</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {currentAdmissions.map((admission, index) => (
                                            <tr key={index}>
                                                <td>
                                                    <strong>{admission.patient}</strong>
                                                </td>
                                                <td>{admission.ward}</td>
                                                <td>{admission.doctor}</td>
                                                <td>{admission.admittedDate}</td>
                                                <td>
                                                    <span
                                                        className={`${classes.statusBadge} ${
                                                            admission.status === "Admitted"
                                                                ? classes.admitted
                                                                : classes.discharged
                                                        }`}
                                                    >
                                                        {admission.status}
                                                    </span>
                                                </td>
                                                <td>
                                                    <span
                                                        className={`${classes.priorityBadge} ${
                                                            admission.priority === "High"
                                                                ? classes.highPriority
                                                                : admission.priority === "Critical"
                                                                ? classes.criticalPriority
                                                                : classes.lowPriority
                                                        }`}
                                                    >
                                                        {admission.priority}
                                                    </span>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                            <div className={classes.pagination}>
                                <span>
                                    Showing {((currentPage - 1) * rowsPerPage) + 1} to{" "}
                                    {Math.min(currentPage * rowsPerPage, recentAdmissions.length)} of{" "}
                                    {recentAdmissions.length} entries
                                </span>
                                <div className={classes.pageButtons}>
                                    <button onClick={handlePrevious} disabled={currentPage === 1}>
                                        <FaChevronLeft />
                                    </button>
                                    {Array.from({ length: totalPages }, (_, index) => (
                                        <button
                                            key={index}
                                            onClick={() => setCurrentPage(index + 1)}
                                            className={currentPage === index + 1 ? classes.activePage : ""}
                                        >
                                            {index + 1}
                                        </button>
                                    ))}
                                    <button onClick={handleNext} disabled={currentPage === totalPages}>
                                        <FaChevronRight />
                                    </button>
                                </div>
                            </div>
                        </div>

                        {/* Right Column */}
                        <div className={classes.rightColumn}>
                            {/* Emergency Cases */}
                            <div className={classes.emergencyCard}>
                                <div className={classes.cardHeader}>
                                    <h3>Emergency Cases</h3>
                                    <span className={classes.viewAll}>View All</span>
                                </div>
                                <div className={classes.emergencyList}>
                                    {emergencyCases.slice(0, 3).map((case_, index) => (
                                        <div key={index} className={classes.emergencyItem}>
                                            <div className={classes.emergencyInfo}>
                                                <span className={classes.emergencyPatient}>{case_.patient}</span>
                                                <span className={classes.emergencyTime}>{case_.arrivedTime}</span>
                                                <span className={classes.emergencyDoctor}>{case_.doctor}</span>
                                            </div>
                                            <span className={classes.emergencyStatus}>{case_.status}</span>
                                        </div>
                                    ))}
                                </div>
                            </div>

                            {/* Recent Activities */}
                            <div className={classes.activitiesCard}>
                                <div className={classes.cardHeader}>
                                    <h3>Recent Activities</h3>
                                    <span className={classes.viewAll}>View All</span>
                                </div>
                                <div className={classes.activitiesList}>
                                    {recentActivities.slice(0, 3).map((activity, index) => (
                                        <div key={index} className={classes.activityItem}>
                                            <span className={classes.activityText}>{activity.activity}</span>
                                            <span className={classes.activityTime}>{activity.time}</span>
                                        </div>
                                    ))}
                                </div>
                            </div>

                            {/* Calendar */}
                            <div className={classes.calendarCard}>
                                <div className={classes.cardHeader}>
                                    <h3>Calendar</h3>
                                    <span className={classes.viewAll}>View All</span>
                                </div>
                                <div className={classes.calendarList}>
                                    {calendarEvents.map((event, index) => (
                                        <div key={index} className={classes.calendarItem}>
                                            <span className={classes.calendarEvent}>{event.event}</span>
                                            <span className={`${classes.calendarStatus} ${
                                                event.status === "In Progress" ? classes.calendarInProgress :
                                                classes.calendarAllDay
                                            }`}>
                                                {event.status}
                                            </span>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Dashboard;